import React from 'react';
import { Row, Col } from 'react-bootstrap';

import InfoRow from 'components/common/InfoRow';
import SubtleBadge from 'components/common/SubtleBadge';

import { TIME_OPTION } from 'constants/time';

const UserViewMode = ({ user }) => {
  return (
    <Row>
      <Col md={4}>
        <InfoRow label="User Name" value={user?.username} />

        <InfoRow label="Email" value={user?.email} />

        <InfoRow label="Phone Number" value={user?.phone} />
      </Col>

      <Col md={4}>
        <InfoRow
          label="User Type"
          value={
            <SubtleBadge bg={user?.is_admin ? 'primary' : 'secondary'}>
              {user?.is_admin ? 'Admin' : 'Staff'}
            </SubtleBadge>
          }
        />

        <InfoRow
          label="Status"
          value={
            <SubtleBadge bg={user?.is_active ? 'success' : 'secondary'}>
              {user?.is_active ? 'Active' : 'Inactive'}
            </SubtleBadge>
          }
        />
      </Col>

      <Col md={4}>
        <InfoRow
          label="Last Login"
          value={new Date(user?.last_login).toLocaleString(
            'en-IN',
            TIME_OPTION,
          )}
        />

        <InfoRow
          label="Created Date"
          value={new Date(user?.created).toLocaleString('en-IN', TIME_OPTION)}
        />
      </Col>
    </Row>
  );
};

export default UserViewMode;
